import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import KycEmbed from "../kyc";
import { enqueueSnackbar } from 'notistack';
import { login } from '../features/user/user';
import { JService, refreshAccessToken } from '../api-service/ApiService';
import { fetchAccountProfile } from '../../utility-functions';
import { useEffect, useState } from 'react';

const SignupKyc = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const userLoginAttemptWith = useSelector((state) => state.user.value);
    const state = location.state;

    const [localState, setLocalState] = useState({secureme_link: null, session_id: null});

    useEffect(() => {
        if(state?.secureme_link && state?.session_id) return;
        onFailed('', true);
    }, []);

    const onPassed = async (response) => {
        console.log("KYC passed:", response);
        enqueueSnackbar("KYC verification completed!", { variant: "success" });
        await fetchAccountProfile();
        await refreshAccessToken();
        
        dispatch(login({ ...userLoginAttemptWith, source: "signup" }));
    }

    const onFailed = async (message, firstLoad = false) => {
        try {
            if(!firstLoad) enqueueSnackbar(message || "KYC process failed. Please try again!", { variant: "error" });
            const response = await JService.post(
                "/api/v1/integrations/kyc/initiate",
            );

            setLocalState({secureme_link: response.secureme_link, session_id: response.session_id});

        } catch(err) {
            enqueueSnackbar("KYC process failed. Please contact support@frejun.com", { variant: "error" })
        }
    }

    return (
        <div style={{ width: "100vw", height: "100vh" }}>
            <KycEmbed
                securemeLink={localState.secureme_link ?? state?.secureme_link}
                sessionId={localState.session_id ?? state?.session_id}
                onPassed={onPassed}
                onFailed={onFailed}
                onRetry={onFailed}
            />
        </div>
    )
}

export default SignupKyc